var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"mt-16 text-center primary--text"},[_vm._v("404")]),_c('h2',{staticClass:"mt-5 text-center secondary-text--text"},[_vm._v("Página não encontrada")])])}
var staticRenderFns = []

export { render, staticRenderFns }